module.exports = __webpack_public_path__ + "static/media/08.a1102470.mp3";